import { makeStyles, withStyles } from '@material-ui/core/styles'
import { TextField } from "formik-material-ui";

export const useStyles = makeStyles((theme) => ({
  forgotPassRoot: {
    height: '95vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    fontFamily: 'Gilroy-Light, serif',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem'
    },
  },




  field: {
    marginTop: '1.5rem',
    alignSelf: "center",
    borderRadius: '25px',
    marginBottom: 22,
    width: "85%",
    height: "30px",

  },
  drop: {
    border: "2px solid #e45826",
    borderRadius: 60,
  },
  card: {
    borderRadius: 40,
    padding: '40px 100px',
    textAlign: 'center',
    backgroundColor: '#fffaf7',
    [theme.breakpoints.down('xs')]: {
      padding: '30px 20px',
    },
  },

  button: {
    borderRadius: '20px',
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '14px',
    backgroundColor: '#e45826',
    color: '#fff',
    width: '160px',
    fontWeight: 400,
    height: 40,
    '&:hover': {
      backgroundColor: '#e45826',
      boxShadow: 'none',
    },
  },
  bottom: {
    marginBottom: '30px',
    textTransform: 'capitalize',
    fontFamily: 'Gilroy-Light, serif',
    color: '#000',
    fontSize: '1.1rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
  },


}))


export const CssTextField = withStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: '#e45826',

    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#e45826',

    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '2px solid #e45826',
        borderRadius: 60,

        height: "50px",
        fontSize: '1.3rem',
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        [theme.breakpoints.down('md')]: {
          height: "50px",
          fontSize: '1.2rem',
        },
        [theme.breakpoints.down('sm')]: {
          height: "50px",
          fontSize: '1.1rem',
        },
        [theme.breakpoints.down('xs')]: {
          height: "45px",
          fontSize: '1rem',
        },

      },
      '&:hover fieldset': {
        borderColor: '#e45826',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#e45826',

      },
    },
  },
}))(TextField);

